/**
 * MembershipRequired Component
 *
 * Displayed when an authenticated user is not an active member.
 * Provides a link to the DAO portal for membership information.
 *
 * Extracted from the custom ProtectedRoute during BL-029.4 migration
 * to be used as the `unauthorizedComponent` prop for the shared ProtectedRoute.
 *
 * @module components/auth/MembershipRequired
 */

export function MembershipRequired() {
  const portalUrl = import.meta.env.VITE_DAO_FRONTEND_URL || 'https://portal.helloworlddao.com';

  return (
    <div className="flex h-screen w-screen items-center justify-center bg-background">
      <div className="max-w-md text-center p-8">
        <h1 className="text-2xl font-bold text-foreground mb-4">Membership Required</h1>
        <p className="text-muted-foreground mb-6">
          Governance is available to active members of the Hello World DAO.
          Visit the DAO portal to learn about membership.
        </p>
        <a
          href={portalUrl}
          className="inline-flex items-center justify-center rounded-md bg-primary px-6 py-3 text-sm font-medium text-primary-foreground hover:bg-primary/90 transition-colors"
        >
          Go to DAO Portal
        </a>
      </div>
    </div>
  );
}

export default MembershipRequired;
